export default __webpack_public_path__ + "static/media/alert-circle-blue.fe0cc074.svg";